import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { Base } from '../../../../components/UpliftAds/components/Banner/components/Base.js';
import { Wrapper } from '../../../../components/UpliftAds/components/Banner/components/Wrapper.js';
import { useImpressionTracking } from '../../../../components/UpliftAds/hooks/useImpressionTracking.js';
export const Banner = ({
  category,
  content,
  impressionUrl,
  viewableImpressionUrl,
  width,
  height,
  className,
  onClick,
  ...props
}) => {
  const element = useRef(null);
  useImpressionTracking({
    element,
    impressionUrl,
    viewableImpressionUrl
  });
  return _jsx(Wrapper, {
    ref: element,
    width: width,
    height: height,
    className: className,
    onClick: onClick,
    children: _jsx(Base, {
      ...props,
      category: category,
      content: content
    })
  });
};